// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapBox_appWrapper__TAGBM {
  border: none;
  width: 100%;
  align-items: center;
  height: 100vh;
  display: flex;
  flex-direction: row;
  font-family: "CaviarDreams";
}

.MapBox_mapWrapper__Y3NKy {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.MapBox_button__NuusY {
  padding: 12px 20px;
  border-radius: 20px;
  color: #f2f2f2;
  background-color: #213245;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  z-index: 500;
  transition: 0.5s;
}

.MapBox_button__NuusY:hover {
  background-color: #2c3e52;
  color: #e0dbdb;
}

.MapBox_switchMode__8N01Q {
  left: 165px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/MapBox/MapBox.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".appWrapper {\n  border: none;\n  width: 100%;\n  align-items: center;\n  height: 100vh;\n  display: flex;\n  flex-direction: row;\n  font-family: \"CaviarDreams\";\n}\n\n.mapWrapper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.button {\n  padding: 12px 20px;\n  border-radius: 20px;\n  color: #f2f2f2;\n  background-color: #213245;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  z-index: 500;\n  transition: 0.5s;\n}\n\n.button:hover {\n  background-color: #2c3e52;\n  color: #e0dbdb;\n}\n\n.switchMode {\n  left: 165px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appWrapper": `MapBox_appWrapper__TAGBM`,
	"mapWrapper": `MapBox_mapWrapper__Y3NKy`,
	"button": `MapBox_button__NuusY`,
	"switchMode": `MapBox_switchMode__8N01Q`
};
export default ___CSS_LOADER_EXPORT___;
